enum Action {
  MOVE = 'move'
}

export default Action;
